/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [['πρωί', 'μεσημ.', 'απόγ.', 'βράδυ'], , ['πρωί', 'μεσημέρι', 'απόγευμα', 'βράδυ']], ,
  [['04:00', '12:00'], ['12:00', '17:00'], ['17:00', '20:00'], ['20:00', '04:00']]
];
